import { Stack } from '@mui/material';
import { ProjectSelector } from './ProjectSelector';

export const ProjectSelectorActions = () => {
    return (
        <Stack sx={{ flexDirection: 'row', justifyContent: 'flex-end', m: 1.5 }}>
            <Stack direction="row" gap={1}>
                <ProjectSelector />
            </Stack>
        </Stack>
    );
};
